<div class="c-thumb">
	<div class="c-image c-image--bg c-image--round c-image--{{ vm.size || 'lg' }}" style="background-image: url('{{ vm.picture?.dataURL || vm.getProfilePictureUrl(vm.user) }}');">
		<loader-overlay *ngIf="vm.processing"></loader-overlay>
	</div>
	<form class="c-form" name="vm.form">
		<div class="c-form__group u-no-m">
			<label for="{{ vm.uid }}" class="c-button c-button--icon c-button--s1 c-button--round c-thumb__extra" [ngClass]="{ 'c-button--xs': vm.size!=='xlarge', 'c-thumb__extra--xl': vm.size==='xlarge', 'c-button--disabled': vm.processing }">
				<i class="o-icon o-icon--edit u-no-mr" aria-hidden="true"></i>
				<span class="u-sr-only">{{ 'Subscription.Button.Edit' | translate }}</span>
			</label>
			<input class="u-hidden" id="{{ vm.uid }}" name="{{ vm.uid }}" type="file" accept="image/*" (change)="onFileSelected($event)" [disabled]="vm.processing">
		</div>
	</form>
</div>
